export function getAccommodationItemsBeforeAfterTourDate(
  accommodationItems: Array<App.Checkout.BedbankHotelItem>,
  beforeAfterTourDate: 'before' | 'after',
  tourCheckIn: string,
  tourCheckOut: string,
): Array<App.Checkout.BedbankHotelItem> {
  return accommodationItems.filter((item) => {
    if (beforeAfterTourDate === 'before') {
      return item.checkOut === tourCheckOut
    }
    if (beforeAfterTourDate === 'after') {
      return item.checkIn === tourCheckIn
    }
  })
}

export function onlyRefundableRate(rate: App.BedbankRate): boolean {
  return rate.refundable || rate.partiallyRefundable
}
